import AgreementSetup from './AgreementSetup.component';

export default AgreementSetup;
